export default __webpack_public_path__ + "static/media/DSC_0544.be7b5d87.jpg";